import dayjs from "dayjs";

import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import Text from "ol/style/Text";
import GeoJSON from "ol/format/GeoJSON";
import Feature from "ol/Feature";

import { sector } from "@turf/turf";

import { getGeometryStyleFromColor, Rotations } from "../map/mapUtil";

// HIMS Color Constants
export const DEFAULT_COLOR = "#2f2f2f"; // Dark Grey
export const ONLINE_COLOR = "#5fa052"; // Green
export const FAILURE_COLOR = "#CB4C4E"; // Red
export const DEGRADED_OUTAGE_COLOR = "#CC5500"; // Orange
export const DEGRADED_COLOR = "#E0D268"; // Yellow
export const START_UP_COLOR = "#90caf9"; // Light Blue

// HIMS Latency Band Constants
export const COOP_NOMINAL_VALUE = 1;
export const COOP_LOW_VALUE = 1.5;
export const COOP_MEDIUM_VALUE = 2;
export const NONCOOP_NOMINAL_VALUE = 2;
export const NONCOOP_LOW_VALUE = 3;
export const NONCOOP_MEDIUM_VALUE = 4;

export const getSystemColorFromType = (type) => {
    let statusColor = ONLINE_COLOR;
    if (type == "FAILURE") {
        statusColor = FAILURE_COLOR;
    }
    if (type == "DEGRADED_OUTAGE") {
        statusColor = DEGRADED_OUTAGE_COLOR;
    }
    if (type == "DEGRADED") {
        statusColor = DEGRADED_COLOR;
    }
    return statusColor;
};

export const getSensorStateColor = (sensorState) => {
    switch (sensorState) {
        case "FAULTED":
            return FAILURE_COLOR;
        case "ONLINE":
            return ONLINE_COLOR;
        case "STARTING_UP":
            return START_UP_COLOR;
        default:
            return DEFAULT_COLOR;
    }
};

export const getNameFromHimsSystem = (system) => {
    return system.name?.toUpperCase().replace(/_/g, " ");
};

export const formatXAxis = (tickItem) => {
    return dayjs.unix(tickItem).format("HH:mm");
};

export const getHimsLabelStyleFromComponent = (component) => {
    const { offsetY, offsetX, textAlign, textBaseline } = Rotations.CENTER_TOP;

    const text = new Text({
        text: component.name,
        font: "8px Arial,sans-serif",
        fill: new Fill({ color: "#fff" }),
        stroke: new Stroke({ color: "#000", width: 3 }),
        offsetY: offsetY,
        offsetX: offsetX,
        textAlign: textAlign,
        textBaseline: textBaseline,
        overflow: true
    });
    return new Style({ text: text });
};

export function getGeometryFromHimsComponent(component) {
    const origin = [component.lon, component.lat];
    const radiusKm = component.radius / 1000;

    const minAngle = typeof component.min_angle === "number" ? component.min_angle : 0;
    const maxAngle = typeof component.max_angle === "number" ? component.max_angle : 360;

    const turfSector = sector(origin, radiusKm, minAngle, maxAngle, { steps: 361 });
    const geojson = new GeoJSON();

    const feature = geojson.readFeature(turfSector);
    return feature.getGeometry();
}

export function getFeaturesFromHimsSensors(sensors) {
    const features = [];

    sensors.forEach((sensor) => {
        if (isNaN(sensor.lat) || isNaN(sensor.lon) || isNaN(sensor.radius)) {
            return;
        }
        const feature = new Feature({
            geometry: getGeometryFromHimsComponent(sensor),
            name: sensor.name,
            sensor: sensor,
            truth_source: sensor.truth_source
        });
        features.push(feature);

        const sensorStyle = getGeometryStyleFromColor("#000000");
        feature.setStyle(sensorStyle);
    });
    return features;
}
